import { useState } from "react";
import { when } from "util/support";
import { ResponseCode } from "consts/api";
import { downloadFile } from "features/general/api";
import useGeneralActions from "features/general/useActions";
import { NotificationSeverity } from "features/general/types";

export const useDownloadFile = (downloadFileApi = downloadFile) => {
    const [isLoading, setLoading] = useState(false);
    const { showNotication } = useGeneralActions();

    const download = async (params: Parameters<typeof downloadFileApi>[0]) => {
        setLoading(true);

        const response = await downloadFileApi(params);

        setLoading(false);

        when(!response.ok, () => showNotication({
            severity: NotificationSeverity.Error,
            message: {
                [ResponseCode.NotFound]: 'File not found.',
            }[response.status] ?? 'An error occurred while downloading the file.'
        }));

        return response;
    };

    return {
        isLoading,
        download
    };
};

export default useDownloadFile;
